import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { LineaService } from './services/linea.service';
import { ILinea, ILineaResponse } from './interfaces/linea.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-abc-lineas',
  templateUrl: './abc-lineas.component.html',
  providers: [MessageService]
})
export class AbcLineasComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedLinea: ILinea | null = null;
  dataSource: ILinea[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'numero_linea', header: 'Número Línea', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private lineaService: LineaService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    
    this.lineaService.getLineasDefault().subscribe({
      next: (response: ILineaResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las líneas'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las líneas'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedLinea = null;
    this.displayDialog = true;
  }

  openUpdate(row: ILinea): void {
    this.selectedLinea = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: ILinea): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Desea eliminar la línea ${row.numero_linea}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.lineaService.deleteLinea(row.numero_linea).subscribe({
          next: (response) => {
            if (response.success || (response.data?.[0]?.error === "0")) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Línea eliminada correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.data?.[0]?.error || 'Error al eliminar la línea'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar la línea'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedLinea = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
} 